export default __webpack_public_path__ + "static/media/1992.2740f8a3.png";